import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';

import {SectionButtonsComponent} from '@core/components/section-buttons/section-buttons.component';
@NgModule({
  declarations: [SectionButtonsComponent],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    CommonModule,
  ],
  exports: [SectionButtonsComponent]
})
export class SectionButtonsModule {}
